import { css } from '@emotion/react';

export const controlsContainerStyle = css`
  margin-top: 1rem;
  grid-template-columns: auto 1fr auto;
  grid-row: 2;
  display: grid;

  .next-button {
    grid-column: 3;
  }
`;
